'use strict';
// Namespace
import * as S from './sgvizler';
export const sgvizler = S;
import * as bordercloudNS from './bordercloud';
export const bordercloud = bordercloudNS;
import * as googleNS from './google';
export const google = googleNS;
import * as d3NS from './d3';
export const d3 = d3NS;
import * as leafletNS from './leaflet';
export const leaflet = leafletNS;
/**
 * Todo
 * @const
 *
 */
export const VERSION = S.Core.VERSION;
/**
 * Todo
 * @const
 */
export const HOMEPAGE = S.Core.HOMEPAGE;
/**
 * Draws the sgvizler-containers with the given element id.
 *
 */
export function containerLoadAll() {
    S.Container.loadAllDependencies();
}
function readOptions(options) {
    if (options) {
        if (typeof options === 'object') {
            google.API.key = options.googleApiKey ? options.googleApiKey : '';
            leaflet.API.osmAccessToken = options.osmAccessToken ? options.osmAccessToken : '';
            if (options.path) {
                S.Core.path = options.path.endsWith('/') ? options.path : options.path + '/';
            }
            else {
                S.Core.path = '';
            }
        }
    }
}
/**
 * Draws the sgvizler-containers with the given element id.
 * @param {string} elementID
 */
export function containerDraw(elementID, options) {
    // S.Container.loadDependenciesId(elementID)
    readOptions(options);
    S.Container.drawWithElementId(elementID);
    return S.Logger;
}
/**
 * Todo.
 */
export function containerDrawAll(options) {
    // S.Container.loadAllDependencies()
    readOptions(options);
    S.Container.drawAll();
    return S.Logger;
}
/**
 * Todo.
 */
export function selectDraw(elementID) {
    // S.Select.loadDependencies()
    S.Select.drawWithElementId(elementID);
    return S.Logger;
}
/**
 * Todo.
 */
export function selectDrawAll() {
    // S.Select.loadDependencies()
    S.Select.drawAll();
    return S.Logger;
}
/**
 * Todo.
 * @param {string} className
 * @param {string} pathDoc
 * @returns {string}
 */
export function getChartDoc(className, pathDoc) {
    return S.Select.getChartDoc(className, pathDoc);
}
/**
 * Todo.
 * @param {string} className
 * @param {string} pathDoc
 * @returns {string}
 */
export function getChartOptions(elementID) {
    let optionsChart = "";
    S.Container.list.forEach((container) => {
        if (container.id === elementID) {
            optionsChart = container.chart.newOptionsRaw;
        }
    });
    return optionsChart;
}
export function encodeHtml(str) {
    return S.Tools.encodeHtml(str);
}
export function decodeHtml(str) {
    return S.Tools.decodeHtml(str);
}
export function giveHTMLAndScript(idDivOfSgvizler, idHtmlOfSgvizler, idScriptOfSgvizler, options) {
    let div = document.getElementById(idDivOfSgvizler);
    let htmlDiv = document.getElementById(idHtmlOfSgvizler);
    let scriptDiv = document.getElementById(idScriptOfSgvizler);
    if (div) {
        if (htmlDiv) {
            htmlDiv.textContent = new XMLSerializer().serializeToString(div)
                .replace(/&#10;/g, "\n")
                .replace(/xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, "")
                .replace(/ data-/gm, "\ndata-");
        }
        if (scriptDiv) {
            let script = "<script src=\"../browser/sgvizler2.js\"><\/script>\n" +
                "<script>\n";
            if (options) {
                script += "var options = {\n" +
                    "             googleApiKey : \"YOUR_GOOGLE_MAP_API_KEY\",\n" +
                    "             //OpenStreetMap Access Token\n" +
                    "             // https://www.mapbox.com/\n" +
                    "             osmAccessToken:  \"YOUR_OSM_ACCESS_TOKEN\"\n" +
                    "};\n";
                script += "//Draw a chart\n" +
                    "//sgvizler2.containerDraw('result',options);\n" +
                    "//or\n" +
                    "//$(\"#result\").containerchart(options);\n" +
                    "\n" +
                    "//Draw all Chart\n" +
                    "sgvizler2.containerDrawAll(options);\n";
            }
            else {
                script +=
                    "//Draw a chart\n" +
                        "//sgvizler2.containerDraw('" + idDivOfSgvizler + "');\n" +
                        "//or\n" +
                        "//$(\"#" + idDivOfSgvizler + "\").containerchart();\n" +
                        "\n" +
                        "//Draw all Chart\n" +
                        "sgvizler2.containerDrawAll();\n";
            }
            script += "<\/script>";
            scriptDiv.textContent = script;
        }
    }
}
export function showTabHtmlAndScript(idDivOfSgvizler, options) {
    $("#" + idDivOfSgvizler).before('<ul class="nav nav-tabs" role="tablist" idDivOfSgvizler="' + idDivOfSgvizler + 'tab">\n' +
        '    <li class="nav-item">\n' +
        '         <a class="nav-link active" data-toggle="tab" href="#' + idDivOfSgvizler + 'Tab" role="tab" aria-expanded="true">Result</a>\n' +
        '         </li>\n' +
        '         <li class="nav-item">\n' +
        '         <a class="nav-link" data-toggle="tab" href="#' + idDivOfSgvizler + 'htmlTab" role="tab" aria-expanded="false">HTML</a>\n' +
        '         </li>\n' +
        '         <li class="nav-item">\n' +
        '         <a class="nav-link" data-toggle="tab" href="#' + idDivOfSgvizler + 'scriptTab" role="tab" aria-expanded="false">Javascript</a>\n' +
        '         </li>\n' +
        '</ul>\n' +
        '<div class="tab-content">\n' +
        '         <div class="tab-pane active" id="' + idDivOfSgvizler + 'Tab" role="tabpanel" aria-expanded="true">' +
        '              <div id="' + idDivOfSgvizler + 'example" style="padding: 25px;"></div>' +
        '         </div>\n' +
        '         <div class="tab-pane" id="' + idDivOfSgvizler + 'htmlTab" role="tabpanel" aria-expanded="false">\n' +
        '            <div class="bg-faded" style="padding: 25px;"><pre lang="html" id="' + idDivOfSgvizler + 'Html"></pre></div>\n' +
        '         </div>\n' +
        '         <div class="tab-pane" id="' + idDivOfSgvizler + 'scriptTab" role="tabpanel" aria-expanded="false">\n' +
        '            <div class="bg-faded" style="padding: 25px;"><pre lang="html" id="' + idDivOfSgvizler + 'Script"></pre></div>\n' +
        '         </div>\n' +
        '</div>');
    var element = $("#" + idDivOfSgvizler).detach();
    $('#' + idDivOfSgvizler + 'example').append(element);
    giveHTMLAndScript(idDivOfSgvizler, idDivOfSgvizler + "Html", idDivOfSgvizler + "Script", options);
}
/**
 * Todo
 * @param {string} elementID
 * @param {string} endpoint
 * @param {string} query
 * @param {string} chartName
 * @param {string} options
 * @param {string} loglevel
 * @returns {string}
 */
export function create(elementID, endpoint, query, chartName, options, loglevel, output, method, parameter, lang) {
    return S.Container.create(elementID, endpoint, query, chartName, options, loglevel, output, method, parameter, lang);
}
// noinspection JSPotentiallyInvalidConstructorUsage
jQuery.fn.extend({
    selectchart: function (param, option) {
        let $this = this;
        let action = 'render';
        if (param) {
            if (typeof param === 'string') {
                action = param;
            }
            else if (typeof param === 'object') {
                action = param.action ? param.action : action;
            }
        }
        // Return the jQuery object for chaining.
        return $this.each(function (index, obj) {
            if (index >= 0 && action === 'render') {
                if (param && typeof param === 'object') {
                    S.Select.draw(obj, param);
                }
                else {
                    S.Select.draw(obj);
                }
            }
        });
    },
    containerchart: function (param, option) {
        let $this = this;
        let action = 'render';
        if (param) {
            if (typeof param === 'string') {
                action = param;
            }
            else if (typeof param === 'object') {
                action = param.action ? param.action : action;
            }
        }
        // Return the jQuery object for chaining.
        return $this.each(function (index, obj) {
            if (index >= 0 && action === 'render') {
                if (param && typeof param === 'object') {
                    readOptions(param);
                }
                S.Container.drawWithElementId($(obj).attr('id'));
            }
        });
    }
});
S.Loader.detectRoot();
//# sourceMappingURL=data:application/json;base64,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